import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import * as Actions from '../constants/all';
import { ISetSearchFiltersAction, IUserCalendarActivitiesSetAction, IUserHomeMyCoursesSetAction, IUserHomeUpcomingActivitiesSetAction } from '../../models/action/userHome';
import { Common } from '../../core/common';
import { ActivityType } from '../../models/enums/ActivityType';
import { IDashboardActivityItem } from '../../models/components/dashboard-activities';

const _logger = Log.create('userHome.ts --> Reducer');
const _common = new Common();

const UserHomePageReducer = (state = GlobalState().userHomePage, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    let newState: any = {};
    if (action.type === Actions.userHomeActions.SET_USER_HOME_CALENDAR_ACTIVITIES) {
        newState = { ...state };
        const userHomePageCalendarAction = (action as IUserCalendarActivitiesSetAction);
        newState.userHomeCalendarIsLoading = userHomePageCalendarAction.userHomeCalendarIsLoading;

        if (userHomePageCalendarAction.userHomeCalendarIsLoading) {
            newState.userHomeCalendarActivities = userHomePageCalendarAction.userHomeCalendarActivities;
            if (userHomePageCalendarAction.skip === 0 && !userHomePageCalendarAction.isNowThenPast) {
                newState.userHomeCalendarActivities = [];
                newState.userHomeCalendarDateArray = [];
            } else {
                newState.userHomeCalendarActivities = state.userHomeCalendarActivities;
                newState.userHomeCalendarDateArray = state.userHomeCalendarDateArray;
            }

            newState.userHomeCalendarActivities = newState.userHomeCalendarActivities.concat(userHomePageCalendarAction.userHomeCalendarActivities);

            newState.userHomeCalendarTake = userHomePageCalendarAction.take;
            newState.userHomeCalendarSkip = userHomePageCalendarAction.skip;
            if (userHomePageCalendarAction.isNowThenPast !== undefined) {
                newState.userHomeisNowThenPast = userHomePageCalendarAction.isNowThenPast;
            }

            let dateArray: Date[] = [];
            if (newState.userHomeCalendarDateArray && newState.userHomeCalendarDateArray.length) {
                dateArray = dateArray.concat(newState.userHomeCalendarDateArray);
            }

            if (userHomePageCalendarAction.isNowThenPast) {
                dateArray.push(new Date('1900-01-01'));
            }

            newState.userHomeCalendarDateArray = dateArray;
            if (userHomePageCalendarAction.userHomeCalendarActivities) {
                userHomePageCalendarAction.userHomeCalendarActivities!.forEach((data) => {
                    const item = dateArray.filter(d => d === data.dueDate);
                    if (!item.length) {
                        dateArray = dateArray.concat(_common.InsertArrayDateDiff(data.dueDate!, data.dueDate!));
                    }
                });

                newState.userHomeCalendarDateArray = dateArray.filter((n, i) => dateArray.indexOf(dateArray.filter(subIndex => new Date(subIndex).getDate() === new Date(n).getDate() && new Date(subIndex).getMonth() === new Date(n).getMonth() && new Date(subIndex).getFullYear() === new Date(n).getFullYear())[0]) === i).sort();
            }
        }




    } else if (action.type === Actions.userHomeActions.SET_USER_HOME_MY_COURSES) {
        newState = { ...state };
        const userHomePageMyCoursesAction = (action as IUserHomeMyCoursesSetAction);
        newState.userHomeMyCourses = userHomePageMyCoursesAction.userHomeMyCourses;
    } else if (action.type === Actions.userHomeActions.SET_USER_UPCOMING_ACTIVITIES) {
        newState = { ...state };
        const userHomePageUpcomingActivitiesAction = (action as IUserHomeUpcomingActivitiesSetAction);
        newState.userUpcomingActivities = userHomePageUpcomingActivitiesAction.upcomingActivities;
    } else if (action.type === Actions.userHomeActions.CLEAR_USER_UPCOMING_ACTIVITIES) {
        newState = { ...state };
        newState.userUpcomingActivities = null;
    } else if (action.type === Actions.userHomeActions.SET_SEARCH_FILTERS) {
        newState = { ...state };
        const userHomePageSearchFiltersAction = (action as ISetSearchFiltersAction);
        newState.searchfilters = userHomePageSearchFiltersAction.searchfilters;

    } else { return state; }
    return Object.assign({}, state, newState);
};

export default UserHomePageReducer;
